import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const CTASection = () => {
  return (
    <section className="py-24 bg-white relative overflow-hidden">
      {/* Decorative Grid Background */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none">
        <div className="grid grid-cols-12 h-full">
          {[...Array(12)].map((_, i) => (
            <div key={i} className="border-r border-[#4D4C4A]"></div>
          ))}
        </div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="border-2 border-[#91756A]/20 p-6 sm:p-12 md:p-20 relative bg-white shadow-sm"
            >
            {/* Top-Left Corner Accent */}
            <div className="absolute -top-1 -left-1 w-8 h-8 md:w-12 md:h-12 border-t-4 border-l-4 border-[#91756A]"></div>
            {/* Bottom-Right Corner Accent */}
            <div className="absolute -bottom-1 -right-1 w-8 h-8 md:w-12 md:h-12 border-b-4 border-r-4 border-[#91756A]"></div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2, duration: 0.8 }}
            >
              <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-[#4D4C4A] leading-tight mb-8 italic tracking-tighter uppercase break-words">
                Build Smarter <br />
                <span className="text-[#91756A]">Infrastructure</span> <br />
                with VASTECH
              </h2>

              <p className="text-slate-500 text-base md:text-xl leading-relaxed mb-12 max-w-2xl mx-auto">
                Partner with our engineering team to design and implement systems that enhance building performance and sustainability.
              </p>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.4, duration: 0.8 }}
                className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-6"
              >
                <Link to="/contact-consultation" className="w-full sm:w-auto">
                  <Button
                    variant="default"
                    className="w-full sm:w-auto bg-[#4D4C4A] hover:bg-[#3d3c3a] text-white px-6 md:px-12 py-5 md:py-8 rounded-none text-xs md:text-sm font-bold uppercase tracking-[0.15em] md:tracking-[0.3em] h-auto group"
                  >
                    Start Your Project
                    <Icon name="ArrowRight" size={16} className="ml-3 group-hover:translate-x-2 transition-transform duration-300" />
                  </Button>
                </Link>
                <Link to="/about-vastech" className="w-full sm:w-auto">
                  <Button
                    variant="outline"
                    className="w-full sm:w-auto border-[#4D4C4A] text-[#4D4C4A] hover:bg-slate-50 px-6 md:px-12 py-5 md:py-8 rounded-none text-xs md:text-sm font-bold uppercase tracking-[0.15em] md:tracking-[0.3em] h-auto"
                  >
                    Learn More
                  </Button>
                </Link>
              </motion.div>            </motion.div>
          </motion.div>
        </div>
      </div>
      
      {/* Background Decorative Circles */}
      <div className="absolute top-1/2 left-0 -translate-x-1/2 -translate-y-1/2 w-64 h-64 border border-[#91756A]/5 rounded-full pointer-events-none"></div>
      <div className="absolute top-1/2 right-0 translate-x-1/2 -translate-y-1/2 w-96 h-96 border border-[#4D4C4A]/5 rounded-full pointer-events-none"></div>
    </section>
  );
};

export default CTASection;